import * as routers from "./router-names";


const routes = [
	{
		path: '/',
		redirect: '/layout'
	},
	{
		path: '/layout',
		name: routers.ROUTER_ROOT,
		redirect: '/layout/home',
		component: () => import('../views/layout/index.vue'),
		children: [
			{
				path: 'home',
				name: routers.ROUTER_HOME,
				component: () => import('../views/home/index.vue'),
			},
			{
				path: 'about',
				name: routers.ROUTER_ABOUT,
				component: () => import('../views/about/index.vue'),
			},
			{
				path: 'foodcompositiontable',
				name: routers.ROUTER_FOODCOMPOSITIONTABLE,
				component: () => import('../views/foodcompositiontable/index.vue'),
				redirect: '/layout/foodcompositiontable/foodClassify',
				children: [
					{
						path: 'foodClassify',
						name: routers.ROUTER_FOODCLASSIFY,
						component: () => import('../components/foodcompositiontable/foodClassify.vue')
					},
					{
						path: 'nutritionAssessment',
						name: routers.ROUTER_NUTRITIONASSESSMENT,
						component: () => import('../components/foodcompositiontable/nutritionAssessment.vue'),
						redirect: '/layout/foodcompositiontable/nutritionAssessment/AssessmentBottom',
						children: [
							{
								path: 'AssessmentBottom',
								name: routers.ROUTER_ASSESSMENTBOTTOM,
								component: () => import('../components/foodcompositiontable/Assessment_bottom.vue'),
							},
							{
								path: 'detail',
								name: routers.ROUTER_DETAIL,
								component: () => import('../components/foodcompositiontable/detail.vue')
							}
						]
					},
					{
						path: 'globalSearch',
						name: routers.ROUTER_GLOBALSEARCH,
						component: () => import('../components/foodcompositiontable/globalSearch.vue')
					},
					{
						path: 'dataCompression',
						name: routers.ROUTER_DATACOMPRESSION,
						component: () => import('../components/foodcompositiontable/dataCompression.vue')
					}
				]
			},
			{
				path: 'Pre_packagedFoodBank',
				name: routers.ROUTER_PRE_PACKAGEFOODBANK,
				component: () => import('../views/Pre_packagedFoodBank/index.vue'),
				redirect: '/layout/Pre_packagedFoodBank/Pre_foodClassify',
				children: [
					{
						path: 'pre_foodClassify',
						name: routers.ROUTER_PRE_FOODCLASSIFY,
						component: () => import('../components/Pre_packagedFoodBank/Pre_foodClassify.vue')
					},
					{
						path: 'Pre_nutritionAssessment',
						name: routers.ROUTE_PRE_NUTRITIONASSESSMENT,
						redirect: '/layout/Pre_packagedFoodBank/Pre_nutritionAssessment/Pre_AssessmentBottom',
						component: () => import('../components/Pre_packagedFoodBank/Pre_nutritionAssessment.vue'),
						children: [
							{
								path: 'Pre_Assessment_bottom',
								name: routers.ROUTER_PRE_ASSESSMENTBOTTOM,
								component: () => import('../components/Pre_packagedFoodBank/Pre_Assessment_bottom.vue'),
							},
							{
								path: 'Pre_detail',
								name: routers.ROUTER_PRE_DETAIL,
								component: () => import('../components/Pre_packagedFoodBank/Pre_detail.vue')
							}
						]
					},
					{
						path: 'Pre_globalSearch',
						name: routers.ROUTER_PRE_GLOBALSEARCH,
						component: () => import('../components/Pre_packagedFoodBank/Pre_globalSearch.vue')
					},
					{
						path: 'Pre_dataCompression',
						name: routers.ROUTER_PRE_DATACOMPRESSION,
						component: () => import('../components/Pre_packagedFoodBank/Pre_dataCompression.vue')
					}
				]
			},
			{
				path: 'nutri-search',
				name: routers.ROUTER_NUTRI_SEARCH,
				component: () => import('../views/nutri-search/index.vue'),
			},

		]
	}
]

export default routes;